/* =====================================================================
   CONFIG — Agar kabhi store / fields dobara banen to sirf yahan IDs badlein.
   Pehle ID se field dhoondi jati hai. ID na mile to LABEL se dhoondi
   jati hai, is liye ID purani reh bhi jaye to code chalta rahega.
   ===================================================================== */
const FIELD_IDS = {
  name:          '6ac661bcba350db4f41e384c',
  event:         '6ac67e55ba350db4f41e3b70',   // is product ka apna Event
  customEvent:   '6ac66f80ba350db4f41e39e7',
  message:       '6ac67697ba350db4f41e3a95',
  customMessage: '6ac674b9ba350db4f41e3a6a'
};

// Backup: agar ID na mile to in labels se field dhoondi jayegi
const FIELD_LABELS = {
  name:          'Name',
  event:         'Event',
  customEvent:   'Custom Event',
  message:       'Special Message',
  customMessage: 'Custom Special Message'
};

// Variant select hone par ye default values bhari jayengi
const DEFAULTS = {
  maleName:   'IBRAHIM',   // Male aur Al-Aqsa
  femaleName: 'FATIMA',
  event:      'For Humanitarian Relief',
  message:    'Because every name counts'
};


/* =====================================================================
   HELPERS
   ===================================================================== */

// Config key se field lo — e.g. pcfField('customEvent')
function pcfField(key) {
  return pcfGetField(FIELD_LABELS[key], FIELD_IDS[key]);
}

// Kisi field element ki config key batao: 'name', 'event', 'customEvent', ...
function pcfKeyOf(el) {
  // 1) ID se
  var id = (el.id || '').replace('product-custom-field-', '');
  for (var k in FIELD_IDS) {
    if (FIELD_IDS[k] && FIELD_IDS[k] === id) return k;
  }

  // 2) Exact label se
  var label = pcfLabelOf(el);
  for (var k2 in FIELD_LABELS) {
    if (FIELD_LABELS[k2].toLowerCase() === label) return k2;
  }

  // 3) Label ke andar ke words se (aakhri koshish)
  if (label.includes('name')) return 'name';
  if (label.includes('event')) return label.includes('custom') ? 'customEvent' : 'event';
  if (label.includes('message')) return label.includes('custom') ? 'customMessage' : 'message';
  return null;
}

// Kisi field ka label text (lowercase) — e.g. "name", "custom event"
function pcfLabelOf(el) {
  return $(el).closest('.product-custom-field-item')
    .children('label').first().text().trim().toLowerCase();
}

// Pehle ID se, phir exact label se field (input/select) dhoondo
function pcfGetField(labelText, id) {
  var byId = id && document.getElementById('product-custom-field-' + id);
  if (byId) return byId;
  if (!labelText) return null;

  var want = labelText.trim().toLowerCase();
  var found = null;
  $('.product-custom-field-item').each(function () {
    var lbl = $(this).children('label').first().text().trim().toLowerCase();
    if (lbl === want) {
      found = $(this).find('.product-custom-field-input').get(0) || null;
      return false;
    }
  });
  return found;
}

// Kaunsa validation lagana hai: name = sirf letters, event/message = letters + numbers
function pcfMode(key) {
  if (key === 'name') return 'letters';
  if (key === 'event' || key === 'customEvent' ||
      key === 'message' || key === 'customMessage') return 'alnum';
  return null;
}

function pcfSanitize(value, mode) {
  if (mode === 'letters') return value.replace(/[^a-zA-Z\s]/g, '');
  return value.replace(/[^a-zA-Z0-9\s]/g, '');
}

function pcfUpdateCharLength(input) {
  if (!input) return;
  const max = input.getAttribute('maxlength') || 0;
  const counter = input.closest('.product-custom-field-input-container')
    ?.querySelector('.product-custom-field-character-length');
  if (counter) counter.innerText = `${input.value.length} / ${max}`;
}

// Select (swatch) ki value ko uske "Custom ..." text field mein copy karo
function pcfCopySelectToText(textKey, hiddenName, value) {
  var textInput = pcfField(textKey);
  if (textInput) {
    var spaceKeyEvent = $.Event('keydown', { keyCode: 32, which: 32 });
    $(textInput).val(value).trigger('focus').trigger(spaceKeyEvent);
    pcfUpdateCharLength(textInput);
  }
  $('input[name="' + hiddenName + '"]').val(value);
}

// Har visible field ki value uske hidden properties[...] input mein daalo
// (hidden input field ke andar ho ya <form> ke andar, dono jagah dhoondta hai)
function pcfSyncHiddenProperties() {
  $('.product-custom-field-input').each(function () {
    var fieldId = (this.id || '').replace('product-custom-field-', '');
    var $hidden = fieldId ? $('#form_field_' + fieldId) : $();
    if (!$hidden.length) {
      $hidden = $(this).closest('.product-custom-field-item')
        .find('input[type="hidden"][name^="properties["]');
    }
    if ($hidden.length) $hidden.val($(this).val() || '');
  });
}


$(document).ready(function () {

  var allowClickAction = false;

  /* -------------------------------------------------------------------
     KEYDOWN VALIDATION — sirf EK baar bind hota hai (delegated),
     har keystroke par naye listeners jama nahi hote.
     ------------------------------------------------------------------- */
  $(document).on('keydown', 'input.product-custom-field-input[type="text"]', function (e) {
    var mode = pcfMode(pcfKeyOf(this));
    if (!mode) return;

    // Ctrl/Cmd shortcuts (copy/paste/select all) allow
    if (e.ctrlKey || e.metaKey) return;

    // Backspace, Tab, Space, Arrows, Delete, aur Android keyboards (229)
    if ([8, 9, 32, 37, 38, 39, 40, 46, 229].includes(e.keyCode)) return;

    var isLetter = e.keyCode >= 65 && e.keyCode <= 90;
    var isDigit = (e.keyCode >= 48 && e.keyCode <= 57 && !e.shiftKey) ||
                  (e.keyCode >= 96 && e.keyCode <= 105);

    if (mode === 'letters' && !isLetter) e.preventDefault();
    if (mode === 'alnum' && !isLetter && !isDigit) e.preventDefault();
  });

  /* -------------------------------------------------------------------
     MAIN HANDLER — overlay preview update
     ------------------------------------------------------------------- */
  $(document).on('input change', '.product-custom-field-input', function (e) {
    var field = this;
    var key = pcfKeyOf(field);

    // User ki typing ko saaf karo (paste / mobile keyboard ke liye bhi)
    if (field.type === 'text' && e.originalEvent && e.originalEvent.isTrusted) {
      var mode = pcfMode(key);
      if (mode) {
        var clean = pcfSanitize(field.value, mode);
        if (clean !== field.value) field.value = clean;
      }
      pcfUpdateCharLength(field);
    }

    var selectedRadio = $('input[type="radio"][name^="Image-1"]:checked');
    const items = $('.thumbnail-list li.thumbnail-list__item');
    const thirdLast = items.eq(-3);
    const secondLast = items.eq(-2);
    const last = items.eq(-1);

    thirdLast.css('display', 'block').addClass('third-last');
    secondLast.css('display', 'block').addClass('second-last');
    last.css('display', 'block').addClass('last');

    setTimeout(function () {
      allowClickAction = true;
    }, 1000);

    var overlayContainer = $();

    if (selectedRadio.val() == 'Male') {
      if (allowClickAction && $('.thumbnail-list .third-last button').attr('aria-current') !== 'true') {
        $('.thumbnail-list .third-last button').trigger('click');
      }
      secondLast.css('display', 'none');
      last.css('display', 'none');
      overlayContainer = $('.product__media-wrapper .third-last-male .product-media-container');

    } else if (selectedRadio.val() == 'Female') {
      if (allowClickAction && $('.thumbnail-list .second-last button').attr('aria-current') !== 'true') {
        $('.thumbnail-list .second-last button').trigger('click');
      }
      thirdLast.css('display', 'none');
      last.css('display', 'none');
      overlayContainer = $('.product__media-wrapper .second-last-female .product-media-container');

    } else if (selectedRadio.val() == 'Al-Aqsa') {
      if (allowClickAction && $('.thumbnail-list .last button').attr('aria-current') !== 'true') {
        $('.thumbnail-list .last button').trigger('click');
      }
      thirdLast.css('display', 'none');
      secondLast.css('display', 'none');
      overlayContainer = $('.product__media-wrapper .last-dome .product-media-container');

    } else {
      console.log('No variant matched:', selectedRadio.val());
    }

    var inputVal = $(field).val() || '';
    var overlayClass = '';
    var overlayText = inputVal;

    if (key === 'name') {
      overlayClass = 'name-overlay';

    } else if (key === 'event' || key === 'customEvent') {
      overlayClass = 'event-overlay';
      if (key === 'event' && $(field).is('select')) {
        pcfCopySelectToText('customEvent', 'properties[Event]', inputVal);
      }

    } else if (key === 'message' || key === 'customMessage') {
      overlayClass = 'message-overlay';
      if (key === 'message' && $(field).is('select')) {
        pcfCopySelectToText('customMessage', 'properties[Special Message]', inputVal);
      }

    } else {
      console.log('Other input:', inputVal);
      return;
    }

    // Variant select nahi hua to overlay ke liye jagah nahi — error ke bajaye ruk jao
    if (!overlayContainer.length) return;

    var wrapper = overlayContainer.find('.overlay-wrapper');
    if (wrapper.length === 0) {
      wrapper = $('<div class="overlay-wrapper"></div>');
      overlayContainer.css('position', 'relative').append(wrapper);
    }

    var existingOverlay = wrapper.find('.' + overlayClass);
    if (existingOverlay.length === 0) {
      wrapper.append($('<div class="overlay-text ' + overlayClass + '"></div>').text(overlayText));
    } else {
      existingOverlay.text(overlayText);
    }

    // Text update hone ke BAAD size adjust karo
    if (overlayClass === 'name-overlay') {
      shrinkOverlayText('.overlay-text.name-overlay');
    }
  });

  /* -------------------------------------------------------------------
     VARIANT CHANGE — preview refresh
     ------------------------------------------------------------------- */
  $(document).on('change', '[id^="variant-selects-template--"] input[type="radio"]', function () {

    var hasValue = false;
    $('.product-custom-field-input').each(function () {
      if ($(this).val() !== '') {
        hasValue = true;
        return false;
      }
    });

    if (!hasValue) return;

    setTimeout(function () {
      const isMobile = window.innerWidth <= 768;

      $('.product-custom-field-input').trigger('input');
      document.activeElement?.blur();

      if (!isMobile) {
        $('.thumbnail-list .thumbnail-list__item:first-child button').trigger('click');
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(function () {
          $('.thumbnail-list .thumbnail-list__item:first-child button').trigger('click');
        }, 100);
      }
    }, 1000);
  });

  /* -------------------------------------------------------------------
     ADD TO CART
     ------------------------------------------------------------------- */
  function showLoader() {
    const loader = document.querySelector('.product-form__submit .loading__spinner');
    const btn = document.querySelector('.product-form__submit');
    if (loader) loader.classList.remove('hidden');
    if (btn) {
      btn.classList.add('loaderbtn');
      btn.disabled = true;
    }
  }

  function hideLoader() {
    const loader = document.querySelector('.product-form__submit .loading__spinner');
    const btn = document.querySelector('.product-form__submit');
    if (loader) loader.classList.add('hidden');
    if (btn) {
      btn.classList.remove('loaderbtn');
      btn.disabled = false;
    }
  }

  function openCartDrawer(cartDrawer, sections) {
    if (!cartDrawer) return;
    cartDrawer.renderContents({ sections: sections });
    cartDrawer.classList.remove('is-empty');
    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      cartDrawer.classList.add('active');
      document.body.classList.add('overflow-hidden');
    }
  }

  $('.product-form__submit').on('click', function (event) {
    event.preventDefault();
    showLoader();

    // 1) Visible fields ki values hidden properties[...] mein daalo
    pcfSyncHiddenProperties();

    // 2) Custom value ho to dropdown wali value khaali karo
    var customEventInput = document.querySelector('input[name="properties[Custom Event]"]');
    var eventInput = document.querySelector('input[name="properties[Event]"]');
    if (customEventInput && customEventInput.value.trim() !== '' && eventInput) {
      eventInput.value = '';
    }

    var customMessageInput = document.querySelector('input[name="properties[Custom Special Message]"]');
    var messageInput = document.querySelector('input[name="properties[Special Message]"]');
    if (customMessageInput && customMessageInput.value.trim() !== '' && messageInput) {
      messageInput.value = '';
    }

    // 3) Form serialize + jo properties form ke BAHAR hain wo bhi add karo
    //    (new store mein custom fields <form> ke bahar render hote hain)
    var $form = $(this).closest('form');
    var formData = $form.serialize();

    var extraProps = $('input[name^="properties["]').filter(function () {
      return !($form[0] && $form[0].contains(this)) && $.trim(this.value) !== '';
    }).serialize();
    if (extraProps) formData += '&' + extraProps;

    formData += '&sections=cart-drawer,cart-icon-bubble';
    formData += '&sections_url=' + window.location.pathname;

    console.log(formData);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',

      success: function (response) {
        hideLoader();
        const cartDrawer = document.querySelector('cart-drawer');

        if (cartDrawer && response.sections) {
          openCartDrawer(cartDrawer, response.sections);
        } else {
          fetch('/?sections=cart-drawer,cart-icon-bubble')
            .then(res => res.json())
            .then(data => openCartDrawer(cartDrawer, data))
            .catch(err => console.error(err));
        }
      },

      error: function (response) {
        hideLoader();
        console.log('Error:', response);
      }
    });
  });

  /* -------------------------------------------------------------------
     MEDIA ITEMS ko classes do (male / female / dome)
     ------------------------------------------------------------------- */
  var observer = new MutationObserver(function (mutationsList, observer) {
    const items = $('.product__media-list li.product__media-item');
    if (!items.length) return; // media abhi load nahi hua, intezar karo

    items.eq(-3).addClass('third-last-male');
    items.eq(-2).addClass('second-last-female');
    items.eq(-1).addClass('last-dome');

    observer.disconnect();
  });

  observer.observe(document, { childList: true, subtree: true });

  /* -------------------------------------------------------------------
     Fields load hon to pehle se bhari values ka preview banao
     ------------------------------------------------------------------- */
  var observer_event = new MutationObserver(function () {
    var $inputs = $('.product-custom-field-input-container .product-custom-field-input');
    if (!$inputs.length) return;

    $inputs.each(function () {
      if ($(this).val() !== '') {
        $(this).trigger('input').trigger('change');
      }
    });
    observer_event.disconnect();
  });

  observer_event.observe(document.body, { childList: true, subtree: true });
});


/* =====================================================================
   SELECT → SWATCHES
   ===================================================================== */
$(document).ready(function () {
  var checkElementInterval = setInterval(function () {
    if (!$('.product-custom-fields-container .product-custom-field-item').length) return;
    clearInterval(checkElementInterval);

    $('select.product-custom-field-input').each(function () {
      var $originalSelect = $(this);

      // Do baar swatches na banen
      if ($originalSelect.next('.swatch-container').length) return;

      var $swatchContainer = $('<div class="swatch-container"></div>');
      $originalSelect.after($swatchContainer);

      $originalSelect.css({
        'position': 'absolute',
        'opacity': 0,
        'pointer-events': 'none',
        'height': 0,
        'width': 0
      });

      $originalSelect.find('option').each(function () {
        var optionValue = $(this).val();
        var optionText = $(this).text();
        if (optionValue === '') return;

        $('<div class="swatch-option"></div>')
          .text(optionText)
          .toggleClass('selected', $(this).is(':selected'))
          .click(function () {
            if ($swatchContainer.hasClass('dragging')) return;

            $originalSelect.val(optionValue);
            $swatchContainer.find('.swatch-option').removeClass('selected');
            $(this).addClass('selected');

            // Native change event — jQuery handlers bhi isi ko pakad lete hain
            $originalSelect[0].dispatchEvent(new Event('change', { bubbles: true }));

            if (typeof CustomFields !== 'undefined' && typeof CustomFields.onInputChange === 'function') {
              CustomFields.onInputChange($originalSelect[0]);
            }
          })
          .appendTo($swatchContainer);
      });

      // Mouse drag scrolling
      let isDown = false;
      let moved = false;
      let startX;
      let scrollLeft;

      $swatchContainer.on('mousedown', function (e) {
        isDown = true;
        moved = false;
        startX = e.pageX - $swatchContainer.offset().left;
        scrollLeft = $swatchContainer.scrollLeft();
      });

      $(document).on('mouseup', function () {
        isDown = false;
        // click event ke baad 'dragging' hatao taake drag ko click na samjha jaye
        setTimeout(function () { $swatchContainer.removeClass('dragging'); }, 0);
      });

      $(document).on('mousemove', function (e) {
        if (!isDown) return;
        const x = e.pageX - $swatchContainer.offset().left;
        const walk = (x - startX) * 2;
        if (Math.abs(walk) > 5 && !moved) {
          moved = true;
          $swatchContainer.addClass('dragging');
        }
        if (!moved) return;
        e.preventDefault();
        $swatchContainer.scrollLeft(scrollLeft - walk);
      });

      $originalSelect.on('change', function () {
        var selectedText = $originalSelect.find('option:selected').text();
        $swatchContainer.find('.swatch-option').removeClass('selected')
          .filter(function () { return $(this).text() === selectedText; })
          .addClass('selected');
      });
    });
  }, 100);
});


/* =====================================================================
   DEFAULT VALUES + PREVIEW BUTTON
   ($(function) use kiya hai taake script late load ho tab bhi chale)
   ===================================================================== */
$(function () {

  function getNameInput() { return pcfField('name'); }
  function getEventSelect() { return pcfField('event'); }
  function getMessageSelect() { return pcfField('message'); }

  function fillNameField(value) {
    const input = getNameInput();
    if (!input) return;

    const nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    nativeSetter.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    pcfUpdateCharLength(input);
    input.blur();
  }

  function selectSwatchAndSync(selectEl, textValue) {
    if (!selectEl) return;
    const want = textValue.trim().toLowerCase();

    const item = selectEl.closest('.product-custom-field-item');
    const swatches = item ? item.querySelectorAll('.swatch-option') : [];

    swatches.forEach((swatch) => {
      const isMatch = swatch.textContent.trim().toLowerCase() === want;
      swatch.classList.toggle('selected', isMatch);
      if (isMatch) {
        swatch.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    });

    for (const opt of selectEl.options) {
      if (opt.textContent.trim().toLowerCase() === want) {
        selectEl.value = opt.value;
        selectEl.dispatchEvent(new Event('change', { bubbles: true }));
        break;
      }
    }
  }

  function scrollToThumb(selector) {
    if (window.innerWidth <= 768) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    if ($(selector).attr('aria-current') !== 'true') {
      $(selector).trigger('click');
    }
  }

  function addPreviewButton() {
    document.querySelector('.preview-button')?.remove();

    const previewButton = document.createElement('button');
    previewButton.className = 'button preview-button';
    previewButton.type = 'button';
    previewButton.innerHTML = `
        <svg viewBox="0 0 1280 1042.0374" width="20" height="20" fill="#fff" class="mr-2">
          <path d="M512 192q-84 0-161 23-77 24-143 66T89 382Q36 441 0 512q36 71 89 130t119 101q66 42 143 66 77 23 161 23t161-23q77-24 143-66t119-101q53-59 89-130-36-71-89-130T816 281q-66-42-143-66-77-23-161-23zm252 170q46 28 83.5 66.5T914 512q-29 45-66.5 83.5T764 662q-56 36-120.5 55T512 736q-67 0-131.5-19T260 662q-46-28-83.5-66.5T110 512q29-45 66.5-83.5T260 362q2-2 5-4l6-4q-7 21-11 43t-4 45q0 53 20 100 20 46 55 81t81 55q47 20 100 20t100-20q46-20 81-55t55-81q20-47 20-100 0-23-4-45t-11-43l6 4q3 2 5 4zm-252 54q0 40-28 68t-68 28q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68z"/>
        </svg> Preview Now`;

    document.querySelector('.product-form__buttons')?.appendChild(previewButton);

    previewButton.addEventListener('click', function () {
      var val = $('input[type="radio"][name^="Image-1"]:checked').val();
      if (val == 'Male') scrollToThumb('.thumbnail-list .third-last button');
      else if (val == 'Female') scrollToThumb('.thumbnail-list .second-last button');
      else if (val == 'Al-Aqsa') scrollToThumb('.thumbnail-list .last button');
      else console.log('Preview: no variant matched', val);
    });
  }

  function handleVariantCheckAndFill() {
    const selectedVariant = document.querySelector('input[type="radio"][name^="Image-"]:checked');
    const variantTitle = selectedVariant?.value?.trim().toLowerCase() || '';

    addPreviewButton();

    const eventSelect = getEventSelect();
    const messageSelect = getMessageSelect();
    if (!eventSelect || !messageSelect) return;

    // NOTE: 'female' ko 'male' se PEHLE check karna zaroori hai
    if (variantTitle.includes('female')) {
      fillNameField(DEFAULTS.femaleName);
    } else if (variantTitle.includes('male') || variantTitle.includes('al-aqsa')) {
      fillNameField(DEFAULTS.maleName);
    } else {
      fillNameField('');
      return;
    }

    selectSwatchAndSync(eventSelect, DEFAULTS.event);
    selectSwatchAndSync(messageSelect, DEFAULTS.message);

    document.activeElement?.blur();
    window.scrollTo(0, 0);
  }

  // Fields aane tak DOM dekhte raho
  const waitForInputs = new MutationObserver(() => {
    if (getNameInput() && getEventSelect() && getMessageSelect()) {
      waitForInputs.disconnect();
      setTimeout(handleVariantCheckAndFill, 300);
    }
  });
  waitForInputs.observe(document.body, { childList: true, subtree: true });

  // Variant change
  document.body.addEventListener('change', function (e) {
    if (
      e.target.matches('select[name="id"]') ||
      e.target.matches('.product__radio input[type="radio"]')
    ) {
      setTimeout(handleVariantCheckAndFill, 300);
    }
  });

  // Initial trigger
  setTimeout(handleVariantCheckAndFill, 1000);
});


/* =====================================================================
   NAME OVERLAY TEXT SIZE
   ===================================================================== */
function shrinkOverlayText(selector, minFontSize = 0.521) {
  document.querySelectorAll(selector).forEach(el => {
    el.style.fontSize = '4.6875vw';
    const containerWidth = el.clientWidth;
    let fontSize = 4.6875; // vw mein hi rakho

    while (el.scrollWidth > containerWidth && fontSize > minFontSize) {
      fontSize -= 0.25;
      el.style.fontSize = fontSize + 'vw';
    }
  });
}

shrinkOverlayText('.overlay-text.name-overlay');

window.addEventListener('resize', () => {
  shrinkOverlayText('.overlay-text.name-overlay');
});